<style lang="scss" scoped>
.slider-label {
  position: relative;
  top: 50%;
  transform: translate(0%, -50%);
}
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}
/* Hide default HTML checkbox */
.switch input {
  display: none;
}
/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}
.slider.disabled {
  cursor: not-allowed;
}
.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked + .slider {
  background-color: #444;
}

.fa-sun {
  display: none;
  color: white;
  position: relative;
  top: 8px;
  left: 7px;
  font-size: 18px;
}

.fa-moon {
  color: white;
  position: relative;
  left: 35px;
  top: 8px;
  font-size: 18px;
}

input:checked + .slider .fa-moon {
  display: none;
}

input:checked + .slider .fa-sun {
  display: block;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

#topNavbarOptions {
  position: relative;
  float: right;
}
</style>
<template>
  <div>
    <navbar :show-navbar="showNavbar">
      <div class="navbar-wrapper">
        <div class="navbar-minimize">
          <button
            id="minimizeSidebar"
            class="btn btn-icon btn-round"
            @click="minimizeSidebar"
          >
            <i
              class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"
            ></i>
            <i
              class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"
            ></i>
          </button>
        </div>
        <div class="navbar-toggle">
          <navbar-toggle-button @click.native="toggleSidebar">
          </navbar-toggle-button>
        </div>
        <a class="navbar-brand" href="#pablo">Admin Panel</a>
      </div>
    </navbar>
    <div id="topNavbarOptions" class="m-3" v-if="checkLoggedIn">
      <drop-down
        icon="nc-icon nc-settings-gear-65"
        tag="li"
        position="right"
        direction="none"
        class="nav-item btn-rotate dropdown"
      >
        <a
          slot="title"
          slot-scope="{ isOpen }"
          class="nav-link dropdown-toggle"
          data-toggle="dropdown"
          aria-haspopup="true"
          :aria-expanded="isOpen"
        >
          <i class="nc-icon nc-settings-gear-65"></i>
        </a>
        <a class="dropdown-item" @click.prevent="logout()" href="#">Abmelden</a>
      </drop-down>
    </div>
    <div style="position: relative;float: right;" class="m-3">
      <label class="switch p-0 m-0">
        <input v-model="darkTheme" @change="changeTheme" type="checkbox" />
        <span class="slider round">
          <i class="fa fa-sun"></i>
          <i class="fa fa-moon"></i>
        </span>
      </label>
    </div>
  </div>
</template>
<script>
import { Navbar, NavbarToggleButton } from "src/components/UIComponents";

export default {
  components: {
    Navbar,
    NavbarToggleButton
  },
  data() {
    return {
      darkTheme: false,
      activeNotifications: false,
      showNavbar: false
    };
  },
  created() {
    this.darkTheme = JSON.parse(localStorage.getItem("darkTheme"));
  },
  computed: {
    checkLoggedIn() {
      return this.$store.getters["user/auth"];
    }
  },
  methods: {
    changeTheme() {
      localStorage.setItem("darkTheme", this.darkTheme);
      this.$bus.$emit("darkTheme", this.darkTheme);
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize();
      if (document.body.offsetWidth < 992) {
        if (!this.isMinimized) {
          document
            .getElementById("topNavbarOptions")
            .classList.toggle("d-none");
        }
      }
    },
    logout() {
      this.$http
        .post("/logout")
        .then(() => {
          window.location = "/";
        })
        .catch(() => {
          window.location = "/";
        });
    }
  }
};
</script>
